<template>
  <History
    v-if="currentOperation"
    :currentOperation="currentOperation"
    :historyURL="historyURL"
    :issueId="issueId"
  />
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useShip, useEquipment } from '@/functions/use_remote_object';

import History from '@/components/history.vue';

const props = defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: false, default: null },
  equipmentId: { type: String, required: false, default: null },
  shipId: { type: String, required: false, default: null },
  shaftId: { type: String, required: false, default: null },
  issueId: { type: String, required: true },
  inspectionId: { type: String, required: true },
});

const route = useRoute();

const currentOperation = ref(getOperation());

const historyURL = computed(() => {
  if (route.name === 'shipIssueHistory') {
    return `/organisations/${props.organisationId}/ships/${props.shipId}/inspections/${props.inspectionId}/issues/${props.issueId}/history`;
  } else if (route.name === 'shaftIssueHistory') {
    return `/organisations/${props.organisationId}/shafts/${props.shaftId}/inspections/${props.inspectionId}/issues/${props.issueId}/history`;
  } else if (route.name === 'shaftV2IssueHistory') {
    return `/organisations/${props.organisationId}/shafts_v2/shafts/${props.shaftId}/inspections/${props.inspectionId}/issues/${props.issueId}/history`;
  } else if (route.name === 'equipmentIssueHistory') {
    return `/organisations/${props.organisationId}/equipment/${props.equipmentId}/inspections/${props.inspectionId}/issues/${props.issueId}/history`;
  } else {
    return `/organisations/${props.organisationId}/operations/${props.operationId}/plants/inspections/${props.inspectionId}/issues/${props.issueId}/history`;
  }
});

function getOperation() {
  let operation = {};
  props.shipId && (operation = useShip(props));
  props.equipmentId && (operation = useEquipment(props));
  return operation;
}
</script>
